import {
  ApprovalAction,
  AssetApprovalActionModel,
  AssetApprovalModel,
  AssetApprovalStatus,
} from '@casops/store/apis/assetApprovalsApi';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './ConflictResolutionMessage.module.scss';

interface ConflictResolutionMessageProps {
  item: AssetApprovalModel;
  action: AssetApprovalActionModel | null;
}

export const ConflictResolutionMessage = ({
  item,
  action,
}: ConflictResolutionMessageProps): ReactNode => {
  const { t } = useTranslation();

  if (action && item.sts === AssetApprovalStatus.Conflict) {
    if (action.action === ApprovalAction.UpdateDeviceName) {
      // Find the matching conflict using the asset name to get the registered asset Device Name.
      const oldDeviceName =
        item.conflicts?.find(conflict => conflict.an === action.an)?.dn || t('Unknown');

      return (
        <div className={styles.helperMessage}>
          {t('ConflictExplainer.UpdateDeviceName', {
            an: action.an,
            dn1: oldDeviceName,
            dn2: action.dn,
          })}
        </div>
      );
    } else if (action.action === ApprovalAction.ReplaceDevice) {
      // Find the matching conflict using the asset name to get the registered asset Device ID.
      const oldDeviceId =
        item.conflicts?.find(conflict => conflict.an === action.an)?.did || t('Unknown');

      return (
        <ol className={`${styles.helperMessage} ${styles.list}`}>
          <li>
            {t('ConflictExplainer.ReplaceDevicePoint1', {
              did1: oldDeviceId,
              did2: action.did,
            })}
          </li>
          <li>{t('ConflictExplainer.ReplaceDevicePoint2', { did: oldDeviceId })}</li>
        </ol>
      );
    }
  }

  return null;
};

export default ConflictResolutionMessage;
